import { ISurcharges } from "@cai-services";
import { AirlineRegions } from "./airline-regions.model";
import { AirlineZones } from "./airline-zones.model";
import { Country } from "./country.model";
import { SpecialHandlingCode } from "./special-handling-code.model";
import { QuoteRateDetail } from "./quote-rate-detail.model";
import { Airport } from "./region-airport.model";
import { AirlineBrand } from "./airline.model";

export class Surcharges implements ISurcharges {
  destRegion: AirlineRegions;
  destCountry: Country;
  destZone: AirlineZones;
  id: number;
  airlineBrand: AirlineBrand;
  country: string;
  surchargeCode: string;
  surchargeName: string;
  fromDate: Date;
  untilDate: Date;
  minAmount: number;
  maxAmount: number;
  formulaKg: number;
  weightType: string;
  perWeight: string;
  destAirport: Airport;
  transitAirport: string;
  product: string;
  rateDetail: QuoteRateDetail[];
  specialHandlingCodes: SpecialHandlingCode[];
  isChecked?: boolean;

  public constructor (init?: Partial<Surcharges>) {
    Object.assign(this, init);
  }
}
